import { createAction } from '@reduxjs/toolkit'

import {
  IAttachNotesPayload,
  IAttachTranscriptPayload,
  IDetachNotesPayload,
  IDetachTranscriptPayload,
  IStartDiscoveryRunPayload,
} from './types'

// All three mutations return "the standard full brief view" on success
// (per the BRAND-9307 as-built contract) — sagas dispatch the EXISTING
// fetchCampaignSuccess action to apply it, so these *Success actions carry
// no response payload: they only clear the transient in-flight UI flag.
// startDiscoveryRunSuccess is the exception: it names the campaign the run
// was started on, because agentSourcedCreatorsReducer listens for it
// cross-slice and its effect (land on the newly started run) is only valid
// for that campaign — see the BRAND-9550 review-fix notes there.

export const attachTranscript = createAction<IAttachTranscriptPayload>(
  'discoveryRuns/attachTranscript',
)
export const attachTranscriptSuccess = createAction('discoveryRuns/attachTranscriptSuccess')
export const attachTranscriptFailure = createAction<string>('discoveryRuns/attachTranscriptFailure')

export const attachNotes = createAction<IAttachNotesPayload>('discoveryRuns/attachNotes')
export const attachNotesSuccess = createAction('discoveryRuns/attachNotesSuccess')
export const attachNotesFailure = createAction<string>('discoveryRuns/attachNotesFailure')

// BRAND-9582 item 13 (FINAL fix): real server-side detach — mirrors the
// attach actions exactly (same *Success/*Failure shape, same "clears the
// in-flight flag only" contract; the server payload lands via the existing
// fetchCampaignSuccess, same as attach).
export const detachTranscript = createAction<IDetachTranscriptPayload>(
  'discoveryRuns/detachTranscript',
)
export const detachTranscriptSuccess = createAction('discoveryRuns/detachTranscriptSuccess')
export const detachTranscriptFailure = createAction<string>('discoveryRuns/detachTranscriptFailure')

export const detachNotes = createAction<IDetachNotesPayload>('discoveryRuns/detachNotes')
export const detachNotesSuccess = createAction('discoveryRuns/detachNotesSuccess')
export const detachNotesFailure = createAction<string>('discoveryRuns/detachNotesFailure')

export const startDiscoveryRun = createAction<IStartDiscoveryRunPayload>(
  'discoveryRuns/startDiscoveryRun',
)
export const startDiscoveryRunSuccess = createAction<{ campaignId: number }>(
  'discoveryRuns/startDiscoveryRunSuccess',
)
export const startDiscoveryRunFailure = createAction<string>(
  'discoveryRuns/startDiscoveryRunFailure',
)
